import { Navigate } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  authenticated,
  ...restProps
}) => authenticated ? <Component {...restProps} /> : <Navigate to="/" />;

export default PrivateRoute;
